import PupilActionTypes from './pupil.types';
import { PURGE } from 'redux-persist';

const INITIAL_STATE = {
  data: null,
  isFetching: false,
  errorMessage: undefined,
};

const pupilReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case PupilActionTypes.FETCH_PUPIL_START:
      return {
        ...state,
        isFetching: true,
      };

    case PupilActionTypes.FETCH_PUPIL_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data.value,
      };
    case PupilActionTypes.FETCH_PUPIL_ERROR:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload,
      };

    case PURGE:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default pupilReducer;
